<template>
  <el-dialog
      v-if="dialogVisible"
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      title="快递信息"
      width="1000px">
    <el-form ref="form" :model="form">
      <el-row>
        <el-col :span="6">
          <el-form-item label="快递类型">{{form.logisticsTitle}}</el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="快递单号">{{form.logisticsNo}}</el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-table
        ref="vmTable"
        module="basic"
        border
        :data="form.list">
      <el-table-column prop="logisticsStatusTime" label="时间" align="left" width="200"/>
      <el-table-column prop="logisticsStatusText" label="状态" align="left"/>
    </el-table>
  </el-dialog>
</template>

<script>

  export default {
    name: "PurchaseOrderAttachment",
    components: {},
    data() {
      return {
        dialogVisible: false,
        form: {
          logisticsTitle: "",
          logisticsNo: "",
          list: [],
        },
      };
    },
    methods: {
      open(row) {
        this.dialogVisible = true;
        const logisticsNo = row.carNo;
        const logisticsTitle = row.carrierName;
        this.form = {
          logisticsTitle: logisticsTitle,
          logisticsNo: logisticsNo,
          list: [],
        };
        if (!logisticsNo) {
          return;
        }
        // 根据物流单号查询快递轨迹
        this.$http
          .get("basic", `shipmentLogisticsDetails/selectByLogisticsNo/${logisticsNo}`)
          .then((resp) => {
            if (Array.isArray(resp)) {
              this.form.list = resp;
            }
          }).catch(() => {
            this.$message.error("快递信息获取失败");
          });
      },
    },
  };
</script>

<style scoped>

</style>
